export default {"src":"/_next/static/media/ilk.73375db6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};